module.exports = __webpack_public_path__ + "img/guitar-electric.76451532.svg";